// default-translations.ts
var fieldManagementTranslations = {
  fieldManagement: {
    search: ["Suchen", "search"],
    addNewField: ["Listen-Feld hinzuf\xFCgen", "add field"],
    save: ["Speichern", "save"],
    close: ["Schlie\xDFen", "close"],
    extraFields: ["zusammengesetzte Felder", "composed fields"],
    fields: ["Felder", "fields"],
    cmsFields: ["benutzerdefinierte Felder", "user defined fields"],
    deleteSelection: ["Auswahl l\xF6schen", "remove selection"]
  },
  field: {}
};
export {
  fieldManagementTranslations
};
